import React, { useState } from "react";
import ReactPlayer from "react-player";
import { IndustrSector } from "./common/Helper";
import { motion, AnimatePresence } from "framer-motion";

const IndustrialSectors = () => {
  const [activeBg, setActiveBg] = useState("");
  return (
    <AnimatePresence>
      <motion.div
        animate={{ opacity: 1, transition: "1s" }}
        id="sectors"
        className={`position-relative h-100vh overflow-hidden ${
          activeBg.bg_image ? activeBg.bg_image : ""
        }`}
      >
        <div className="position-absolute w-100 vh-100">
          {activeBg === "" ? (
            <ReactPlayer
              className="react-player"
              url="https://vz-e28eac45-f0a.b-cdn.net/5ccfb894-fdfe-4ff5-99f3-17c68459987b/playlist.m3u8"
              width="100%"
              playing={true}
              loop={true}
              muted={true}
              height="100%"
            />
          ) : (
            ""
          )}
        </div>

        <div className={`container`}>
          <h4
            className={`text-center py-lg-5 py-sm-4 py-3 font-medium ff_josfin mb-0 font-xl`}
          >
            INDUSTRIAL SECTORS WE SERVE
          </h4>

          <div className="row justify-content-center my-sm-3 mw_industry mx-auto">
            {IndustrSector.map((item, i) => {
              return (
                <div
                  className="col-md-4 col-6 my-sm-0 pt-4"
                  data-aos="zoom-in"
                  data-aos-delay={`${(i + 1) * 200}`}
                  key={i}
                >
                  <div
                    className="sector_card py-sm-3 py-2 px-2 h-100"
                    onMouseOver={() => setActiveBg(item)}
                    onMouseLeave={() => setActiveBg("")}
                  >
                    <div className="text-center svg_image">{item.img}</div>
                    <h4 className="text-center sector_text pt-sm-4 pt-2 font-sm2 ff_josfin">
                      {item.text}
                    </h4>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default IndustrialSectors;
